// JWT 토큰을 localStorage 에 저장/조회/삭제하는 유틸리티
// HttpOnly 쿠키가 더 안전하나, 현재 아키텍처에서는 localStorage 사용

const ACCESS_TOKEN_KEY = 'heinrich_access_token'
const REFRESH_TOKEN_KEY = 'heinrich_refresh_token'

export const tokenStorage = {
  getAccess: (): string | null => localStorage.getItem(ACCESS_TOKEN_KEY),
  getRefresh: (): string | null => localStorage.getItem(REFRESH_TOKEN_KEY),

  setAccess: (token: string): void => {
    localStorage.setItem(ACCESS_TOKEN_KEY, token)
  },

  setTokens: (access: string, refresh: string): void => {
    localStorage.setItem(ACCESS_TOKEN_KEY, access)
    localStorage.setItem(REFRESH_TOKEN_KEY, refresh)
  },

  clearAll: (): void => {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
  },
}
